export const AUTH_COMMIT_CANCELLED = 'Авторизация не завершена.';
let generation = 0;
const subscribers = new Set();
const cancelled = () => {throw new Error(AUTH_COMMIT_CANCELLED);};

// Internal lifecycle seam only. Never expose token/decoded claims in events.
export const commitAuthToken = (token, options) => {
  if (options !== undefined) {
    if (options === null || typeof options !== 'object' || Array.isArray(options)) cancelled();
    if (options.canCommitToken !== undefined) {
      try {
        if (typeof options.canCommitToken !== 'function' || options.canCommitToken() !== true) cancelled();
      } catch {cancelled();}
    }
  }
  if (!Number.isSafeInteger(generation + 1)) cancelled();
  generation += 1;
  const event = Object.freeze({generation, commitContext: options?.commitContext});
  try {for (const notify of [...subscribers]) notify(event);} catch {cancelled();}
  localStorage.setItem('token', token);
};
export const getAuthCredentialGeneration = () => generation;
export const subscribeAuthTokenCommit = listener => {
  if (typeof listener !== 'function') cancelled();
  subscribers.add(listener);
  return () => subscribers.delete(listener);
};
